import { Checkbox } from "@cmp-src/primitives/checkbox";
import React from "react";
import { useDataMan } from "../../hooks/useDataMan";
import { DATA_MAN_CHECKBOX_CLASS } from "./dataManCheckboxClass";

export const DataManSelectAllControl: React.FC = () => {
  const { toggleSelectAll, isAllSelected, selectedItems, data } = useDataMan();

  const hasData = data && data.length > 0;
  const isIndeterminate = selectedItems.length > 0 && !isAllSelected;

  const handleCheckedChange = React.useCallback(() => {
    toggleSelectAll();
  }, [toggleSelectAll]);

  if (!hasData) {
    return null;
  }

  return (
    <Checkbox
      checked={isAllSelected ? true : isIndeterminate ? "indeterminate" : false}
      onCheckedChange={handleCheckedChange}
      className={DATA_MAN_CHECKBOX_CLASS}
    />
  );
};
